import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { TerritoriesPage } from "@/components/territories/territories-page";
import { Route as authenticatedRoute } from "../_authenticated";

// Viewers allowed to see the Territories page (mirrors the server allow-list).
const VIEWERS = new Set([
  "awillard@faithfulplatform.com",
  "jpolson@faithfulplatform.com",
  "nspalding@faithfulplatform.com",
]);

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/territories",
  component: TerritoriesGuard,
});

function TerritoriesGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();
  const user = session?.user as { role?: string; email?: string } | undefined;
  const allowed = user?.role === "admin" || (user?.email && VIEWERS.has(user.email.toLowerCase()));

  if (session && !allowed) {
    navigate({ to: "/my-dashboard" });
    return null;
  }
  return <TerritoriesPage />;
}
